var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":"Payment Successful","ok-only":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('p',[_vm._v("Your payment was successful! Thank you for your purchase.")])])}
var staticRenderFns = []

export { render, staticRenderFns }